import { render } from "./DummyTag.vue?vue&type=template&id=fd8e15a6&lang=pug"
import script from "./DummyTag.vue?vue&type=script&setup=true&lang=js"
export * from "./DummyTag.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__